import { Http } from "@/network/http"
import {
  CashFlow,
  CashFlowResponse,
  CashFlowsResponse,
  CashFlowsSummaryResponse,
  CreateCashFlowDto,
  GetCashFlowsDto,
  UpdateCashFlowDto,
} from "../types"

const BASE_URL = "/cash-flows"


export const fetchCashFlows = async (params?: GetCashFlowsDto): Promise<CashFlowsResponse> => {
  return Http.get(BASE_URL, { params })
}


export const fetchCashFlow = async (id: string): Promise<CashFlowResponse> => {
  return Http.get(`${BASE_URL}/${id}`)
}

export const createCashFlow = async (data: CreateCashFlowDto): Promise<CashFlowResponse> => {
  return Http.post(BASE_URL, data)
}


export const updateCashFlow = async (id: string, data: UpdateCashFlowDto): Promise<CashFlowResponse> => {
  return Http.put(`${BASE_URL}/${id}`, data)
}

export const deleteCashFlow = async (data: CashFlow): Promise<void> => {
  return Http.delete(`${BASE_URL}/${data.id}`)
}


export const confirmCashFlow = async (id: string): Promise<CashFlowResponse> => {
  return Http.post(`${BASE_URL}/${id}/confirm`)
}


export const unconfirmCashFlow = async (id: string): Promise<CashFlowResponse> => {
  return Http.post(`${BASE_URL}/${id}/unconfirm`)
}

export const fetchCashFlowsSummary = async (
  fromDate?: string,
  toDate?: string
): Promise<CashFlowsSummaryResponse> => {
  const params: any = {}
  if (fromDate) params.from_date = fromDate
  if (toDate) params.to_date = toDate
  
  return Http.get(`${BASE_URL}/summary/overview`, { params })
} 